/* eslint-disable no-param-reassign,consistent-return */

// Prompt the user before navigating away from current page, if they made changes to the form
// In order for this to work, call this.setInitialFormValue(initialFormValue) in form view/component

const unsavedChangesMixin = {
  data() {
    return {
      initialFormValue: {},
      currentFormValue: {},
    };
  },

  mounted() {
    window.addEventListener('beforeunload', this.beforeUnload);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnload);
  },

  methods: {
    setInitialFormValue(value) {
      this.initialFormValue = JSON.parse(JSON.stringify(value));
      this.currentFormValue = value;
    },

    beforeUnload(event) {
      if (JSON.stringify(this.initialFormValue) === JSON.stringify(this.currentFormValue)) {
        return;
      }

      const msg = this.$t('common.beforeUnloadMessage');

      event.returnValue = msg; // supposedly this method is deprecated,
      // but this is the one that works on most browsers

      // this is how it is supposed to work, but very few browsers support this
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
      event.preventDefault();

      // and then some older ones apparently expect a return value. Front end dev is fun
      return msg;
    },
  },
};

export default unsavedChangesMixin;
